function ChatMessageItemLocation(props) {
  const { locationContent, lang } = props;

  const mapLink = `https://maps.google.com/?q=${locationContent.latitude},${locationContent.longitude}`;

  return (
    <div
      className="msg chat-message-item-location"
      role="button"
      tabIndex={0}
      onClick={() => {
        if (mapLink) {
          window.open(mapLink, "_blank", "noopener,noreferrer");
        }
      }}
      onKeyDown={(event) => {
        if ((event.key === "Enter" || event.key === " ") && mapLink) {
          event.preventDefault();
          window.open(mapLink, "_blank", "noopener,noreferrer");
        }
      }}
    >
      <div className="location-map-container">
        <img
          src="/public/img/map-location.jpg"
          alt={
            locationContent.title ||
            locationContent.address ||
            "Shared Location"
          }
          className="location-map-image"
        />
      </div>
      {locationContent?.title ? (
        <div
          className="location-display-text-title"
          style={{ paddingBottom: locationContent?.address ? "4px" : "16px" }}
          dangerouslySetInnerHTML={{
            __html: locationContent.title || "Shared Location",
          }}
        ></div>
      ) : null}
      {locationContent?.address ? (
        <div
          className="location-display-text"
          dangerouslySetInnerHTML={{
            __html: locationContent.address || "Shared Location",
          }}
        ></div>
      ) : null}
      <div className="location-divider"></div>
      <div className="location-footer">
        <span className="location-footer-left">
          <img
            className="location-pin-icon"
            src="/public/img/pin_map.png"
            alt=""
            aria-hidden="true"
          ></img>
          <span className="location-footer-label">{lang["__location"]}</span>
        </span>
        <span aria-hidden="true" className="location-arrow">
          <svg
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 4L13 10L7 16"
              stroke="#4D94FF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}
